import React from 'react';
import Skeleton from 'react-loading-skeleton';

const AdminUsersListItemLoading = () => (
  <tr>
    <td className="selector" />
    <th scope="row" className="user-name">
      <Skeleton width="150px" />
    </th>
    <td className="user-email">
      <Skeleton width="200px" />
    </td>
    <td className="user-role">
      <Skeleton width="100px" />
    </td>
    <td className="user-registered">
      <Skeleton width="120px" />
    </td>
    <td className="action-more">
      <Skeleton width="30px" />
    </td>
  </tr>
);

AdminUsersListItemLoading.propTypes = {
};

export default AdminUsersListItemLoading;
